export default "__VITE_ASSET__Cbmad4Wp__"